import React, {FC} from 'react';
import styled from 'styled-components';

import {CellsPanelId, ViewerPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {InboxesTopbar} from '../../components/inboxes/topbar/inboxesTopbar';
import {ConversationHeaderContainer} from '../../components/inboxes/viewer/conversation/header/conversationHeaderContainer';
import {ConversationTopbarContainer} from '../../components/inboxes/viewer/conversation/topbar/conversationTopbarContainer';
import {ViewerContainer} from '../../components/inboxes/viewer/viewerContainer';
import {InboxesVisualConversationSelection} from '../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {ViewerPanelPageState} from '../../store/panels/viewer/viewerPanelState';

/*
 * Props.
 */

interface AuditTrailViewerProps {
  panelId: ViewerPanelId;
  cellsPanelId: CellsPanelId;
  /** Whether this component is visible on screen. Used for Apple Handoff. */
  isActive: boolean;
  page: ViewerPanelPageState;
  conversationSelection: InboxesVisualConversationSelection;
}

/*
 * Styles.
 */

const StyledViewerDiv = styled.div`
  display: grid;
  grid-template-rows: 100%;
  flex-direction: column;
  grid-column: 3;
  grid-row: 3;
`;

const StyledFlexViewerContainer = styled.div`
  flex: 1;
  display: grid;
`;

const StyledInboxesTopBar = styled.div`
  grid-column: 1 / -2;
  grid-row: 1;
`;

/*
 * Component.
 */

export const AuditTrailViewer: FC<AuditTrailViewerProps> = (props) => {
  const {panelId, cellsPanelId, page, conversationSelection} = props;
  return (
    <>
      <StyledInboxesTopBar>
        <InboxesTopbar
          panelId={panelId}
          cellsPanelId={undefined}
          isInPopup={false}
          filters={undefined}
          cellsContext={page.cellsContext}
          parameters={page.parameters}
          conversationSelection={conversationSelection}
        />
      </StyledInboxesTopBar>
      <StyledViewerDiv>
        <StyledFlexViewerContainer>
          <ViewerContainer
            panelId={panelId}
            cellsPanelId={cellsPanelId}
            isActive={props.isActive}
            renderTopbar={({isOffline}) => (
              <ConversationTopbarContainer
                panelId={props.panelId}
                cellsPanelId={undefined}
                isInPopup={false}
                cellsContext={page.cellsContext}
                inboxesParameters={page.parameters}
                conversationSelection={conversationSelection}
                isOffline={isOffline}
              />
            )}
            renderHeader={() => (
              <ConversationHeaderContainer
                panelId={panelId}
                cellsPanelId={undefined}
                cellsContext={page.cellsContext}
                inboxesParameters={page.parameters}
                conversationSelection={conversationSelection}
              />
            )}
            contentPage={page}
            canComposerPopout
          />
        </StyledFlexViewerContainer>
      </StyledViewerDiv>
    </>
  );
};
